import { MediaEntity } from '@/modules/medias/domain/entities/MediaEntity';
import { ProgramEntity } from '@/modules/programs/domain/entities/ProgramEntity';
import { Langs } from '@/types/lang';
import { SearchResult, SearchTypes } from '@/types/search';
import { requestQuery } from '@/services/request';
import { coreSearchResults } from '@/modules/search/domain/routes/searchRoutes';
import { RoleEntity } from '@/modules/user/domain/entities/RoleEntity';
import { Media, Program, Role } from '@/types';
import { SearchResultEntity } from '@/modules/search/domain/entities/SearchResultEntity';

type SearchResults = Record<SearchTypes, (Program | Media | Role)[]>;

export const getSearchResults = async (search: string) => {
  const searchResult: SearchResults = {
    [SearchTypes.Program]: [],
    [SearchTypes.Media]: [],
    [SearchTypes.Role]: [],
  };

  if (!search) return searchResult;

  try {
    const response = await requestQuery<SearchResult[]>({
      url: coreSearchResults,
      params: {
        q: search,
        lang: Langs.Fr,
      },
    });

    response && new SearchResultEntity(response);

    (response || []).forEach((d) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      searchResult[d.doc_type] = d.items.map((b: Program | Media | Role | any) => {
        if (d.doc_type === SearchTypes.Program) return new ProgramEntity(b);
        if (d.doc_type === SearchTypes.Media) return new MediaEntity(b);
        if (d.doc_type === SearchTypes.Role) return new RoleEntity(b);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }) as any[];
    });

    return searchResult;
  } catch (e) {
    return searchResult;
  }
};
